import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "./App";

const MajorFunds = () => {
  const { theme } = useContext(ThemeContext);
  const [teamInvestment, setTeamInvestment] = useState(0);
  const [loanStatus, setLoanStatus] = useState("");
  const [loanActive, setLoanActive] = useState(false);
  const [cooldownEnd, setCooldownEnd] = useState(null);
  const [loading, setLoading] = useState(true);

  // Project colors (match Funds.js)
  const colors = {
    background: theme === "dark" ? "#121212" : "#f2f4f8",
    card: theme === "dark" ? "#333" : "#fff",
    border: theme === "dark" ? "#444" : "#e0e0e0",
    boxShadow: theme === "dark"
      ? "0 8px 20px rgba(255,255,255,0.15)"
      : "0 8px 20px rgba(0,0,0,0.15)",
    text: theme === "dark" ? "#f1f1f1" : "#333",
    accent: theme === "dark" ? "#1e88e5" : "#007bff",
    inputBg: theme === "dark" ? "#232323" : "#fff",
    inputBorder: theme === "dark" ? "#444" : "#ddd",
    modalBg: theme === "dark" ? "#232323" : "#fff",
    modalText: theme === "dark" ? "#f1f1f1" : "#333",
    modalBoxShadow: theme === "dark"
      ? "0 8px 20px rgba(255,255,255,0.15)"
      : "0 8px 20px rgba(0,0,0,0.15)",
  };

  useEffect(() => {
    // Fetch user's team investment for the current month and loan status
    const userId = localStorage.getItem("userId");
    if (!userId) return;
    setLoading(true);
    fetch(`https://tradespots.online/api/funds/major-funds-info?userId=${userId}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setTeamInvestment(data.teamInvestment || 0);
          setLoanActive(data.loanActive || false);
          setCooldownEnd(data.cooldownEnd || null);
        }
        setLoading(false);
      });
  }, []);

  const eligibleLoan = teamInvestment > 0 ? Math.floor(teamInvestment * 0.2 * 10000) / 10000 : 0;

  const handleApplyMajorLoan = async () => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setLoanStatus("User not logged in.");
      return;
    }
    setLoanStatus("Processing major loan...");
    const res = await fetch("https://tradespots.online/api/funds/major-funds-loan", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId })
    });
    const data = await res.json();
    if (data.success) {
      setLoanStatus(`Major loan of ${eligibleLoan} SPOT credited! You can take another after 30 days.`);
      setLoanActive(true);
      setCooldownEnd(data.cooldownEnd);
    } else {
      setLoanStatus(data.error || "Major loan failed.");
    }
  };

  const handleRepayMajorLoan = async () => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setLoanStatus("User not logged in.");
      return;
    }
    setLoanStatus("Processing repayment...");
    const res = await fetch("https://tradespots.online/api/funds/major-funds-repay", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId })
    });
    const data = await res.json();
    if (data.success) {
      setLoanStatus("Major loan repaid successfully.");
      setLoanActive(false);
    } else {
      setLoanStatus(data.error || "Repayment failed.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: colors.background,
        color: colors.text,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Segoe UI', sans-serif",
        padding: 24,
      }}
    >
      <button
        onClick={() => window.history.length > 1 ? window.history.back() : window.location.assign('/funds')}
        style={{
          position: "absolute",
          top: 24,
          left: 24,
          backgroundColor: colors.accent,
          color: "#fff",
          border: "none",
          borderRadius: 8,
          padding: "8px 16px",
          fontWeight: "bold",
          fontSize: 16,
          cursor: "pointer",
          boxShadow: colors.boxShadow,
          zIndex: 10,
        }}
      >
        ← Back
      </button>
      <div
        style={{
          background: colors.card,
          borderRadius: 16,
          boxShadow: colors.boxShadow,
          border: `1px solid ${colors.border}`,
          padding: 32,
          maxWidth: 400,
          width: "100%",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: colors.accent, marginBottom: 16 }}>Major Funding</h2>
        {loading ? (
          <div>Loading...</div>
        ) : (
          <>
            <div style={{ marginBottom: 16 }}>
              <strong>Your Team's Total Investment (This Month):</strong>
              <div style={{ fontSize: 22, margin: 8 }}>{teamInvestment} SPOT</div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <strong>Eligible Major Loan (20%):</strong>
              <div style={{ fontSize: 22, margin: 8 }}>{eligibleLoan} SPOT</div>
            </div>
            <button
              onClick={handleApplyMajorLoan}
              disabled={loanActive || eligibleLoan <= 0}
              style={{
                backgroundColor: colors.accent,
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "12px 24px",
                fontSize: 16,
                fontWeight: "bold",
                cursor: loanActive || eligibleLoan <= 0 ? "not-allowed" : "pointer",
                marginBottom: 16,
                width: "100%",
                transition: "background-color 0.3s",
                opacity: loanActive || eligibleLoan <= 0 ? 0.7 : 1,
              }}
            >
              {loanActive ? "Major Loan Active" : "Apply for Major Loan"}
            </button>
            {loanActive && (
              <button
                onClick={handleRepayMajorLoan}
                style={{
                  backgroundColor: '#e53935',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 8,
                  padding: '12px 24px',
                  fontSize: 16,
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  marginBottom: 16,
                  width: '100%',
                  transition: 'background-color 0.3s',
                }}
              >
                Repay Major Loan
              </button>
            )}
            {cooldownEnd && (
              <div style={{ margin: "12px 0", color: colors.accent, fontWeight: "bold" }}>
                Next eligible date: {new Date(cooldownEnd).toLocaleString()}
              </div>
            )}
            {loanStatus && (
              <div style={{ marginTop: 12, color: loanActive ? colors.accent : "red", fontWeight: "bold" }}>{loanStatus}</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MajorFunds;
